import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { OntologyRoutePage } from "../app/ontologyRoute";

export const Route = createFileRoute("/ontology")({
  component: OntologyRoute,
});

function OntologyRoute(): JSX.Element {
  const search = Route.useSearch();
  return <OntologyRoutePage search={search} />;
}
